import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteTag } from 'api/Tags';

import { showAlert } from 'components/shared/Alert/Alert';
import Button from 'components/shared/Buttons/Button';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Allowed from 'components/shared/Permissions/Allowed';

import { kindToQuery } from '../lib/kindsToQuery';

const ButtonActions = ({ selectedRows, setSelectedRows }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutateAsync: mutateDeleteTag } = useMutation({
    mutationFn: (data) => deleteTag(navigate, data)
  });

  const handleContinue = async () => {
    const tagIds = selectedRows?.map((s) => s?.data?.id);
    const tagKinds = selectedRows
      ?.map((s) => s?.data?.kind)
      .filter(Boolean)
      .reduce((acc, kind) => {
        if (!acc.includes(kind)) {
          acc.push(kind);
        }
        return acc;
      }, []);
    await mutateDeleteTag(
      { tagIds },
      {
        onSuccess: () => {
          tagKinds.map((kind) => {
            const queries = kindToQuery?.[kind] || kindToQuery.default;

            queries?.forEach((key) => {
              queryClient.refetchQueries([key]);
            });
          });
          queryClient.invalidateQueries(['allTags']);
          showAlert({ title: 'Tag deleted successfully!', color: 'success' });
          setShowDeleteModal(false);
        }
      }
    );

    setSelectedRows([]);
  };

  return (
    <>
      <Allowed requiredPermissions="tags.delete">
        <Button
          color="danger"
          text="Delete"
          icon="trash-mono"
          size="small"
          iconColor="white"
          onClick={() => setShowDeleteModal(true)}
        />
      </Allowed>

      {showDeleteModal && (
        <Confirm
          variant="danger"
          primaryBtnTxt={`Yes, delete ${selectedRows.length > 1 ? 'tags' : 'tag'}`}
          title={`Delete ${selectedRows.length} selected ${selectedRows.length > 1 ? 'tags' : 'tag'}`}
          icon="calendar-remove-mono"
          message={`Are you sure you want to delete ${selectedRows.length} selected ${selectedRows.length > 1 ? 'tags' : 'tag'}?`}
          handleOpen={showDeleteModal}
          handleContinue={handleContinue}
          handleClose={() => setShowDeleteModal(false)}
        />
      )}
    </>
  );
};

export default ButtonActions;
